module.exports = __webpack_public_path__ + "media/images/favicon/favicon-114-af03043fc6272e80d6e3338709895c94.png";